import { type ActionReducerMapBuilder, type AsyncThunk, type Draft } from '@reduxjs/toolkit';

export const addAsyncStatusCases = <
  TState extends Record<string, any>,
  TReturned,
  TThunkArg,
  TThunkApiConfig extends Record<string, unknown> = {},
>(
  builder: ActionReducerMapBuilder<TState>,
  asyncAction: AsyncThunk<TReturned, TThunkArg, TThunkApiConfig>,
  setter: (state: Draft<TState>, status: 'pending' | 'fulfilled' | 'rejected') => void,
) => {
  builder
    .addCase(asyncAction.pending, (state) => {
      setter(state, 'pending');
    })
    .addCase(asyncAction.fulfilled, (state) => {
      setter(state, 'fulfilled');
    })
    .addCase(asyncAction.rejected, (state) => {
      setter(state, 'rejected');
    });
};
